module.exports = __webpack_public_path__ + "static/media/lead-delete-newer.dc45393d.svg";